export default __webpack_public_path__ + "static/media/background.97f32314.webp";